import { checkPermission } from "@/services/utils";

export default user => {
  const menus = [
    {
      route: "home",
      text: "Painel",
      icon: "equalizer",
      module: null
    },
    {
      route: "customers",
      text: "Clientes",
      icon: "storefront",
      module: "customer"
    },
    {
      route: "users",
      text: "Usuários",
      icon: "people",
      module: "user"
    },
    {
      route: "questions",
      text: "Questões",
      icon: "library_books",
      module: "question"
    },
    {
      route: "quizzes",
      text: "Questionários",
      icon: "assignment",
      module: "quiz"
    },
    {
      route: "quiz-export",
      text: "Exportar",
      icon: "cloud_download",
      module: "quiz",
      permission: "export"
    },
    {
      route: "user-edit",
      text: "Minha Conta",
      icon: "person",
      module: "user",
      permission: "create",
      params: { id: user.uuid },
      class: {
        "hide-on-large-only": true
      }
    }
  ];

  if (user.role == null || user.role.slug == "ADMIN") return menus;

  return menus.filter(menu =>
    checkPermission(
      { module: menu.module, permission: menu.permission },
      user.role
    )
  );
};
